import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-mission-green text-spanish-ivory py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-tile-pattern opacity-5"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10 text-center md:text-left">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-16">
          <div className="max-w-sm">
            <span className="font-serif text-3xl tracking-[0.3em] text-antique-gold block mb-4">
              PADUA WEDDINGS
            </span>
            <p className="text-spanish-ivory/60 text-sm leading-relaxed mb-6">
              A historic Spanish Revival estate in Claremont, California, offering an elevated setting for corporate milestones and holiday celebrations.
            </p>
            <div className="h-0.5 w-12 bg-antique-gold"></div>
          </div>

          <div className="grid grid-cols-2 gap-12">
            <div>
              <h4 className="font-serif text-antique-gold mb-6 uppercase tracking-widest text-xs font-bold">Location</h4>
              <p className="text-spanish-ivory/60 text-sm leading-relaxed">
                Claremont, CA<br />
                Serving the Inland Empire &<br />
                San Gabriel Valley
              </p>
            </div>
            <div>
              <h4 className="font-serif text-antique-gold mb-6 uppercase tracking-widest text-xs font-bold">Contact</h4>
              <p className="text-spanish-ivory/60 text-sm leading-relaxed">
                Corporate Events Division<br />
                events@paduaweddings.com
              </p>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-spanish-ivory/10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-xs text-spanish-ivory/40 tracking-wider">
            &copy; {new Date().getFullYear()} PADUA WEDDINGS. ALL RIGHTS RESERVED.
          </p>
          <div className="flex gap-8">
            <a href="#" className="text-xs text-spanish-ivory/40 hover:text-antique-gold transition-colors tracking-widest uppercase">Privacy</a>
            <a href="#" className="text-xs text-spanish-ivory/40 hover:text-antique-gold transition-colors tracking-widest uppercase">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;